import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogModule, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { FilterService } from '../../@theme/services/filter.service';

@Component({
  selector: 'gd-cap-fax',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonsModule],
  templateUrl: './capitalfax.component.html',
})
export class CapitalFaxComponent {
  public aftersubmit = false;
  public dialogRef: DialogRef | null = null;

  @ViewChild('contentTemplate') contentTemplate!: TemplateRef<any>;

  constructor(private fx: FilterService, private dialogService: DialogService) {
    this.changeDeviceStatus();
  }

  changeDeviceStatus(): void {
    this.aftersubmit = true;
    this.fx.GetemptyCODFaxReturndata().subscribe((response) => {
      const url = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'CODFaxCoversheet.docx';
      link.click();
      URL.revokeObjectURL(url);
    });
  }

  openDialog(): void {
    this.dialogRef = this.dialogService.open({
      title: 'Capital Fax',
      content: this.contentTemplate,
      actions: [
        { text: 'Close', primary: true }
      ],
      width: 450,
      height: 250
    });
  }
}
